<template>
    <footer class="foot">
        <nav>
            <ul>
                <li><a href="Conditions.pdf" target="_blank">AGB</a></li>
                <li><a href="https://de.rs-online.com/web/generalDisplay.html?id=aboutRS/privacy-policy" target="_blank">Datenschutzerklärung</a></li>
            </ul>
        </nav>
    </footer>
</template>
<script>
export default {
    name: 'AppSiteFooter'
}
</script>
<style scoped>

</style>